export default "/list/static/images/how-this-works.svg";